export const SYDNEY_TIMEZONE = 'Australia/Sydney';

export const getBrowserTimeZone = (): string =>
	Intl.DateTimeFormat().resolvedOptions().timeZone || SYDNEY_TIMEZONE;
